import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dropdown d-block"
}
const _hoisted_2 = {
  class: "btn btn-link p-0 ms-1",
  "data-bs-toggle": "dropdown",
  ref: "button"
}
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.content)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fas fa-question-circle" }, null, -1)
        ]))], 512),
        _createElementVNode("div", {
          class: "dropdown-menu dropdown-menu-end dropdown-help shadow fw-normal p-3",
          innerHTML: _ctx.content
        }, null, 8, _hoisted_3)
      ]))
    : _createCommentVNode("", true)
}